import type { BasemapId } from '../core/types';

export interface ConnectivityState {
  readonly online: boolean;
  readonly label: 'Online' | 'Offline';
  readonly remoteBasemapUnavailable: boolean;
}

export const connectivityState = (online: boolean, basemap: BasemapId, showBasemap: boolean): ConnectivityState => ({
  online,
  label: online ? 'Online' : 'Offline',
  remoteBasemapUnavailable: !online && showBasemap && basemap !== 'none',
});

export const canApplyPwaUpdate = (projectDirty: boolean): boolean => !projectDirty;

export const isStandaloneDisplay = (matchMedia: Pick<MediaQueryList, 'matches'>, navigatorStandalone = false): boolean => (
  matchMedia.matches || navigatorStandalone
);
